import { useDecision } from '@optimizely/react-sdk';

import { FeatureFlags, WorkflowUxVariables } from '@frontend/constants/featureFlags';

export function useWorkflowUx() {
  const [decision] = useDecision(FeatureFlags.WORKFLOW_UX);
  const vars = decision?.variables;

  return {
    naturalLanguageConditions: Boolean(vars?.[WorkflowUxVariables.NATURAL_LANGUAGE_CONDITIONS]),
    revampedNavigationLayout: Boolean(vars?.[WorkflowUxVariables.REVAMPED_NAVIGATION_LAYOUT]),
    conditionElseBranches: Boolean(vars?.[WorkflowUxVariables.CONDITION_ELSE_BRANCHES]),
    workflowLogsExport: Boolean(vars?.[WorkflowUxVariables.WORKFLOW_LOGS_EXPORT]),
    staticParameters: Boolean(vars?.[WorkflowUxVariables.STATIC_PARAMETERS]),
    enableAskOpalForWorkflowExecution: Boolean(
      vars?.[WorkflowUxVariables.ENABLE_ASK_OPAL_FOR_WORKFLOW_EXECUTION]
    ),
    executionLogsTreeView: Boolean(vars?.[WorkflowUxVariables.EXECUTION_LOGS_TREE_VIEW]),
    workflowNesting: Boolean(vars?.[WorkflowUxVariables.WORKFLOW_NESTING]),
    workflowBuilderUxV2: Boolean(vars?.[WorkflowUxVariables.WORKFLOW_BUILDER_UX_V2]),
    workflowGlobalSearch: Boolean(vars?.[WorkflowUxVariables.WORKFLOW_GLOBAL_SEARCH]),
  };
}
